import { render, staticRenderFns } from "./PluginSettings.vue?vue&type=template&id=47096d97&scoped=true"
import script from "./PluginSettings.vue?vue&type=script&lang=js"
export * from "./PluginSettings.vue?vue&type=script&lang=js"
import style0 from "./PluginSettings.vue?vue&type=style&index=0&id=47096d97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47096d97",
  null
  
)

export default component.exports